import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Laram from './pages/Laram';
// Removed unused imports: Brand, AboutUs
import About from './pages/About';
import Blog from './pages/Blog';
import Products from './pages/Products';
// Removed unused imports: Step, Blogc
import AddProduct from './pages/AddProduct';
import Middle from './pages/Middle';
import InventoryManagement from './pages/InventoryManagement'; 
import ViewAnalysis from './pages/ViewAnalysis';
import Orders from './pages/Orders'
// Removed unused import: Chatbot
import B1Page from './pages/b1pages';
import B2Page from './pages/b2pages';
import B3Page from './pages/b3pages';
import ProtectedRoute from "./components/ProtectedRoute";
import ProductDetails from "./components/ProductDetails";
import FFA from './components/FFAproducts';
import SGA from './components/SGAproducts';
import HFA from './components/HFAproducts';
import DMA from './components/DMAproducts';
import FLA from './components/FLAproducts';
import SA from './components/SAproducts';
import OrderDetails from './components/OrderDetails';
import OrderConfirmation from './components/OrderConfirmation';
import Wishlist from './pages/Wishlist';

import Cart from './pages/Cart';
import BuyNow from './components/BuyNow';
import Product from './pages/product';
import Checkout from './components/Checkout';
import UserOrder from './pages/UserOrder';
import KFS from './components/KFAproducts';
import KSA from './components/KSAproducts';
import Login from './pages/login';
import Visitor from './pages/Visitor';
import NewVisitor from './pages/NewVisitor';
import VisitorDetails from './pages/VisitorDetails';
import { CreateAdmin } from './pages/CreateAdmin';
import { StoreLayout } from './components/StoreLayout';
import { StoreManagement } from './pages/StoreManagement';
import { InventoryManage } from './pages/InventoryManage';
import { Sales } from './pages/Sales';
import PatientDetails from './pages/PatientDetails';
import { Reminder } from './pages/Reminder';
import { OrderingStatus } from './pages/OrderingStatus';
import AddCoopound from './pages/AddCoopound';

function App() {
  return (
    <div className="App bg-sec">
      <BrowserRouter>
        <Routes>
          <Route
            index
            element={
              <div>
                <Product />
                
              </div>
            }
          />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/products" element={<Products />} />
          <Route path="/b1" element={<B1Page />} />
          <Route path="/b2" element={<B2Page />} />
          <Route path="/b3" element={<B3Page />} />
          <Route path="/Laram" element={<Laram />} />
          <Route path="/product-details" element={<ProductDetails />} />
          <Route path="/ffa" element={<FFA />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path='/UserOrder'element={<UserOrder/>}/>
          <Route path="/sga" element={<SGA />} />
          <Route path="/hfa" element={<HFA />} />
          <Route path="/dma" element={<DMA />} />
          <Route path="/fla" element={<FLA />} />
          <Route path="/sa" element={<SA />} />
          <Route path="/kfs" element={<KFS />} />
          <Route path="/ksa" element={<KSA />} />
          <Route path='/login' element={<Login/>}/>
          
          <Route path="/cart" element={<Cart />} />
          <Route path="/BuyNow" element={<BuyNow />} />
          <Route path="/product" element={<Product />} />
          <Route path="/OrderDetails" element={<OrderDetails />} />
          <Route path="/OrderConfirmation" element={<OrderConfirmation />} />
          <Route path="/Checkout" element={<Checkout />} />

         
          

          {/* Protected Route for Middle.js */}
          <Route
            path="/Middle"
            element={
              <ProtectedRoute>
                <Middle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/VisitorDetails/:email"
            element={
              <ProtectedRoute>
                <VisitorDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/NewVisitor"
            element={
              <ProtectedRoute>
                <NewVisitor />
              </ProtectedRoute>
            }
          />

          {/* Protected Route for AddProduct */}
          <Route
            path="/AddProduct"
            element={
              <ProtectedRoute>
                <AddProduct />
              </ProtectedRoute>
            }
          />
          {/* Protected Route for Inventory Management */}
          <Route
            path="/Orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          />

          {/* Protected Route for Inventory Management */}
          <Route
            path="/InventoryManagement"
            element={
              <ProtectedRoute>
                <InventoryManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ViewAnalysis"
            element={
              <ProtectedRoute>
                <ViewAnalysis />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Visitor"
            element={
              <ProtectedRoute>
                <Visitor />
              </ProtectedRoute>
            }
          />

          {/* Protected Route for CreateAdmin */}
          <Route
            path="/CreateAdmin"
            element={
              <ProtectedRoute>
                <CreateAdmin />
              </ProtectedRoute>
            }
          />

          {/* Protected Route for StoreManagement redirect */}
          <Route
            path="/StoreManagement"
            element={<Navigate to="/Sales" replace />}
          />

          {/* Store Layout Wrapping the 5 main pages */}
          <Route element={<StoreLayout />}>
            <Route
              path="/InventoryManage"
              element={
                <ProtectedRoute>
                  <InventoryManage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Sales"
              element={
                <ProtectedRoute>
                  <Sales />
                </ProtectedRoute>
              }
            />
            <Route
              path="/PatientDetails"
              element={
                <ProtectedRoute>
                  <PatientDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Reminder"
              element={
                <ProtectedRoute>
                  <Reminder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/OrderingStatus"
              element={
                <ProtectedRoute>
                  <OrderingStatus />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Protected Route for AddCoopound */}
          <Route
            path="/AddCoopound"
            element={
              <ProtectedRoute>
                <AddCoopound />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;